<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Integrações da plataforma</span>
        <h1>Documentação</h1>
        <p>Consulte as orientações para envio de gravações via API ou SFTP.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-xxl-12">
        <div class="card mb-25 border-0 radius-7 bg-white">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing d-flex flex-column">
            <p class="mb-30 fs-18 documentation-intro">Atualmente existem 2 formas de realizar integração com nosso sistema para armazenar as gravações em nuvem.</p>

            <div class="sv-section-heading">
              <h2>1 — Upload via API</h2>
            </div>

            <p class="fs-16 ms-10">Se você está utilizando Asterisk ou outro framework para controlar suas ligações, você pode integrar suas gravações via CURL para fazer upload em um dos nossos endpoints, desta forma você será capaz de acompanhar todo o realtime e ter as métricas em tempo real.</p>

            <p class="fs-16 ms-10">Para realizar os uploads via API, primeiro é necessário pegar o token da operação no modulo de <strong>Configurações &gt; Operações</strong> para utilizar na API quando enviar seus arquivos de áudio.</p>

            <p class="mt-30 fs-16"><strong>Token da operação desejada:</strong></p>

            <img class="images-documentation mb-40" src="../../assets/images/documentation/token_operation.png" alt="Localização do token da operação">

            <p class="fs-16 mt-30"><strong>Exemplo de integração via API/CURL:</strong></p>

            <img class="images-documentation mb-40" src="../../assets/images/documentation/regra_de_discagem.jpg" alt="Exemplo de regra de discagem">

            <img class="images-documentation mb-40" src="../../assets/images/documentation/hungup.png" alt="Exemplo de integração no encerramento da chamada">

            <div class="sv-section-heading">
              <h2>2 — Upload via SFTP</h2>
            </div>

            <p class="fs-16 ms-10">Ao optar por realizar os uploads via SFTP, o sistema automaticamente irá buscar as gravações em seu servidor de telefonia de acordo com o tempo que você desejar e na pasta que você especificar.</p>

            <p class="fs-16 ms-10">Nesta modalidade você também pode optar por apagar as gravações que o sistema já copiou, desta forma seu servidor sempre terá o espaço liberado.</p>

            <p class="fs-16 mt-30"><strong>Exemplo de configuração SFTP em: Configurações &gt; Editar Operação</strong></p>

            <img class="images-documentation mb-40" src="../../assets/images/documentation/edit_operation.png" alt="Edição da operação">

            <img class="images-documentation mb-40" src="../../assets/images/documentation/new_configuration_sftp.png" alt="Nova configuração SFTP">

            <img class="images-documentation mb-40" src="../../assets/images/documentation/configuration_sftp.png" alt="Campos da configuração SFTP">

            <p class="fs-16 ms-10">Após realizar a configuração necessária, o sistema já será capaz de buscar as gravações no local indicado.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DocumentationPage",
});
</script>

<style scoped>
.documentation-intro {
  max-width: 760px;
  color: var(--sv-muted);
  line-height: 1.7;
}

.images-documentation {
  width: 100%;
}
</style>
